import SearchVMBase from "Lib/Fs.SmartClient.Client/SearchVMBase";
import PagingCriteria from "Lib/Fs.Core.Data/PagingCriteria";
import SortingCriteria from "Lib/Fs.Core.Data/SortingCriteria";
import SortBy from "Lib/Fs.Core.Data/SortBy";
import { useView, autoinject, Container } from 'aurelia-framework'
import FsUtility from "Lib/Fs.SmartClient.Client/FsUtility";
import { fs } from "config/FsConfig";
import { Router } from 'aurelia-router'
import { DialogService } from 'aurelia-dialog';
import ManageUserEditorVM from "./ManageUserEditorVM";
import UserData01 from "../../../Core/Scripts/AppServiceContract/UserData01";
import ManageUserGroupMemberSearchParameter from "../../Scripts/AppServiceContract/ManageUserGroupMemberSearchParameter";
import UserCriteria01 from "../../../Core/Scripts/UserCriteria01";
import ManageUserAppService from "../../Scripts/AppServiceContract/ManageUserAppService";
import UserData from "../../Scripts/UserData";
import ImportModalVM from "../../Components/Modal/ImportModalVM";
import { inject } from 'aurelia-framework';
import DetailModalVM from "../../Components/Modal/DetailModalVM";
import { PLATFORM } from 'aurelia-pal';

@autoinject
@inject(DialogService)
@useView(PLATFORM.moduleName('./ManageUserSearchView.html'))
export default class ManageUserSearchVM extends SearchVMBase<ManageUserEditorVM>{
    Code: string;
    Name: string;
    IsActive: boolean;
    IsActiveList: [];
    dialogService: DialogService;
    DefaultGroupCode: string;
    ItemsProvider: any;
    template: any;
    router: Router;
    importmodel: DetailModalVM = new DetailModalVM();

  constructor(dialogService) {
    super(ManageUserEditorVM);
        var self = this;
        this.dialogService = dialogService
        this.router = Container.instance.get(Router);
        this.IsSearchAfterSave = true;
        this.IsClearSelectionAfterSave = true;
        this.Search();

    }
    getTemplate(e: any) {
        var key = e.target.data('title');
        this.CurrentItem.ErrorList = this.CurrentItem.getValidateErrors(key);
        return () => this.template.template
    }

    SearchItems(searchCallback: (result: UserData01[]) => void, sortingCriteria: SortingCriteria, pagingCriteria: PagingCriteria) {
        var self = this;

        var service = Container.instance.get(ManageUserAppService) as ManageUserAppService;

        var criteria = new ManageUserGroupMemberSearchParameter();
        criteria = this.CreateCriteria();
        criteria.SortingCriteria = sortingCriteria;
        criteria.PagingCriteria = pagingCriteria;

        service.Find(criteria)
            .done((result) => {
                searchCallback(result);
            }).fail(FsUtility.CommonErrorHandler);
    }

    PrepareDefaultSortingCriteria(sortingCriteria: SortingCriteria) {
        var sortBy = new SortBy();
        sortBy.Direction = 0;
        sortBy.Name = "Code";
        sortingCriteria.push(sortBy);
    }

    CountItems(countCallback: (result: number) => void) {
        var self = this;
        var req = self.CreateCriteria();

      var service = Container.instance.get(ManageUserAppService) as ManageUserAppService;

      if (!this.CheckCriteriaEquals(req.Criteria)) {
        this.SearchCriteria = req.Criteria;
        service.Count(req.Criteria)
            .done((result) => {
                countCallback(result)
            }).fail(FsUtility.CommonErrorHandler);
      } else {
        countCallback(this.ItemCount);
      }
    }

  SearchCriteria: UserCriteria01;

  CheckCriteriaEquals(searchCriteria: UserCriteria01) {
    if (this.SearchCriteria == null) return false;
    return JSON.stringify(this.SearchCriteria) == JSON.stringify(searchCriteria);
  }

    CreateCriteria(): ManageUserGroupMemberSearchParameter {
        var req = new ManageUserGroupMemberSearchParameter();
        var cri = new UserCriteria01();
        cri.Code = $.trim(this.Code);
        cri.Name = $.trim(this.Name);
        cri.IsGroup = false;
        req.Criteria = cri;
        return req;
    }

    RemoveCommand(editorVM: ManageUserEditorVM) {
        super.RemoveCommand(editorVM);
    }

    Clear(): void {
        this.Code = null;
        this.Name = null;
        this.IsActive = null;
        this.Search();
    }

    AddCommand() {
        window.location.href = fs.Config.UserDetailUrl;
    }

  OpenModal() {
        this.dialogService.open({
          viewModel: ImportModalVM,
            model: {
                viewModel: this.importmodel,
              view: PLATFORM.moduleName('Modules/Core/Components/Modal/DetailModalFileView.html'),
                IsShowCancel: true,
                Header: "Manage User"
            }, lock: true
        }).whenClosed(response => {
            if (!response.wasCancelled) {
                this.ImportFile(response.output);
            } 
        });
    }
    async ImportFile(obj) {
        try {
            var service = this.container.get(ManageUserAppService) as ManageUserAppService;
            await service.Import(obj.Obj)
                .done((result) => {
                    FsUtility.AlertModal("The item has been import successfully", 2, 1);
                }).fail((error) => {
                    FsUtility.CommonErrorHandler(error);
                });
            this.Search();

        } catch (err) {
            FsUtility.AlertErrorMessage(err);

        }
    }

}
